import '../styles/rhapsody.css';
import { useRevealObserver } from '../components/motion';
import { Nav } from '../components/Nav';
import Footer from '../components/Footer';
import { JsonLd } from '../components/seo/JsonLd';
import { PageSeo } from '../components/seo/PageSeo';
import { buildMarketingPageSchema } from '../lib/schema';
import { RHAPSODY_META } from '../lib/seo';
import { RhapsodyHero } from '../components/rhapsody/RhapsodyHero';
import { RhapsodyProblem } from '../components/rhapsody/RhapsodyProblem';
import { RhapsodyFeatures } from '../components/rhapsody/RhapsodyFeatures';
import { RhapsodyLoop } from '../components/rhapsody/RhapsodyLoop';
import { RhapsodyModules } from '../components/rhapsody/RhapsodyModules';
import { RhapsodyOneLiner } from '../components/rhapsody/RhapsodyOneLiner';

export function RhapsodyPage() {
  useRevealObserver();

  return (
    <>
      <PageSeo meta={RHAPSODY_META} />
      <JsonLd
        data={buildMarketingPageSchema(
          RHAPSODY_META.title,
          RHAPSODY_META.path,
          RHAPSODY_META.description,
        )}
      />
      <div id="grain" aria-hidden="true" />
      <Nav />
      <main className="rhapsody-page">
        <RhapsodyHero />
        <RhapsodyProblem />
        <section className="rh-section band-dark" aria-labelledby="video-continuity-title">
          <div className="container max-w-3xl py-20">
            <h2 id="video-continuity-title" className="mkt-section-title">What Is AI Video Continuity?</h2>
            <p className="body-lg">AI video continuity is when characters, wardrobe, locations, and story logic stay consistent from the first shot to the last — the problem every clip-based generator has, and the one Rhapsody was built to solve.</p>
          </div>
        </section>
        <RhapsodyFeatures />
        <RhapsodyLoop />
        <RhapsodyModules />
        <RhapsodyOneLiner />
      </main>
      <Footer wordmark="RHAPSODY" />
    </>
  );
}
